import { IconButton, Tooltip } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useThemeStore } from '../../../store/theme';

export const LayoutThemeToggle = () => {
  const { t } = useTranslation();
  const { isDarkMode, toggleTheme } = useThemeStore();

  return (
    <Tooltip title={t('theme.toggleTheme')}>
      <IconButton color="inherit" onClick={toggleTheme}>
        {isDarkMode ? <Brightness7 /> : <Brightness4 />}
      </IconButton>
    </Tooltip>
  );
};
